module.exports = __webpack_public_path__ + "home_branch_1.png?c7d4831fed240ca849a66875e6c16e4e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_branch_1.png
// module id = 50
// module chunks = 0